import { ref } from '@vue/composition-api';

const showGalleryManager = ref(false);

export const useEditGridGallery = () => ({ showGalleryManager });
